<div class="ntb" *ngIf="a">
  <!-- KAPCSOLT: a Könyvelés technikai felhasználója -->
  <ng-container *ngIf="!a.szerkesztheto">
    <p class="ntb-sugo" *ngIf="!a.login">
      Nincs NAV technikai felhasználó. Kapcsolt módban a Könyvelésben adható meg (Törzsadatok → NAV technikai felhasználó) – a Számla és Kassza ugyanazt használja.
    </p>
    <p class="ntb-sugo" *ngIf="a.login">A technikai felhasználó a Könyvelésből jön (kapcsolt mód); a teszt/éles környezetet az ottani jelölő dönti el.</p>
  </ng-container>

  <!-- ÖNÁLLÓ: saját technikai felhasználó -->
  <ng-container *ngIf="a.szerkesztheto && urlap">
    <p class="ntb-sugo">Önálló mód: a cég saját NAV technikai felhasználója (a NAV Online Számla felhasználókezelőjéből). A nyugta-adatszolgáltatáshoz ugyanez kell, a nyugta-jogosultsággal.</p>
    <div class="ntb-racs">
      <label>Felhasználónév<input [(ngModel)]="urlap.login" [disabled]="!ir" autocapitalize="off"></label>
      <label>Adószám<input [(ngModel)]="urlap.adoszam" [disabled]="!ir" placeholder="12345678-1-12"></label>
      <label>Jelszó {{ a.van_jelszo ? '(megadva – üresen marad)' : '' }}<input type="password" [(ngModel)]="urlap.jelszo" [disabled]="!ir" autocomplete="new-password"></label>
      <label>Aláírókulcs {{ a.van_signkey ? '(megadva – üresen marad)' : '' }}<input type="password" [(ngModel)]="urlap.signkey" [disabled]="!ir" autocomplete="off"></label>
      <label>Cserekulcs {{ a.van_exchangekey ? '(megadva – üresen marad)' : '' }}<input type="password" [(ngModel)]="urlap.exchangekey" [disabled]="!ir" autocomplete="off"></label>
      <label class="ntb-jel"><input type="checkbox" [(ngModel)]="urlap.sandbox" [disabled]="!ir"> Teszt környezet (sandbox)</label>
    </div>
  </ng-container>

  <div class="ntb-gombok">
    <button type="button" class="ntb-gomb" *ngIf="a.szerkesztheto && ir" (click)="ment()" [disabled]="fut">Mentés</button>
    <button type="button" class="ntb-gomb masod" (click)="proba()" [disabled]="fut || (!a.login && !a.szerkesztheto)">Kapcsolat próbája</button>
    <span class="ntb-ok" *ngIf="uzenet">{{ uzenet }}</span>
    <span class="ntb-hiba" *ngIf="hiba">{{ hiba }}</span>
  </div>
</div>
<div class="ntb-hiba" *ngIf="!a && hiba">{{ hiba }}</div>
